import SimpleSelect from "component/Common/simpleSelect";
import useApiClient from "hooks/useApiClient";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

const FlightBookingsModificationArea = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { api, urls } = useApiClient();
    const [searchParams] = useSearchParams();
    const pnr = searchParams.get("pnr");
    const name = searchParams.get("name");
    const [formData, setFormData] = useState({
        changeType: "",
        details: "",
    });
    const [ sending , setSending ] = useState(false);

    if (!pnr || !name) {
        navigate("/");
        return null;
    }

	const typeList = [
		{ value: "modification", label: "Demande de modification" },
		{ value: "cancellation", label: "Demande d’annulation" },
		{ value: "information", label: "Demande d’informations" },
		{ value: "baggage", label: "Demande de changement de bagages" },
	];

    const handleSubmit = (e) => {
        e.preventDefault();
        if(sending) return
        if (!formData.changeType || !formData.details.trim()) {
            toast.error("Veuillez remplir tous les champs requis.");
            return;
        }
        const payload = {
            pnr,
            type: formData.changeType,
            details: formData.details.trim(),
            name
        };
        setSending(true);
        api.post(urls.flight.flightBookingModificationRequest, JSON.stringify(payload))
            .then((response) => {
                if(response?.data?.success){
                    toast.success("Votre demande a été envoyée avec succès.");
                    setFormData((prev) => ({
                        ...prev,
                        details: "",
                    }));
                }else{
                    toast.error( "Une erreur est survenue. Veuillez réessayer plus tard.");
                }
            })
            .catch((error) => {
                console.error("Erreur lors de l'envoi de la demande :", error);
                toast.error("Une erreur est survenue. Veuillez réessayer plus tard.");
            })
            .finally(() => {
                setSending(false);
            });
    };

    return (
        <section className="flex justify-center my-10">
            <div className="w-full max-w-2xl bg-white shadow-md rounded-2xl p-6">
                <form onSubmit={handleSubmit} className="space-y-10">
                    {/* Select input */}
                    <div>
                        <label
                            htmlFor="changeType"
                            className="block text-gray-700 font-medium mb-2"
                        >
                            Que souhaitez-vous modifier ?
                        </label>
                        <SimpleSelect
                            searchable={false}
                            options={typeList}
                            placeholder={t(
                                "Sélectionner le type de modification"
                            )}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    changeType: e.value,
                                }));
                            }}
                            dashed={true}
                        />
                    </div>

                    {/* Textarea */}
                    <div className="s">
                        <label
                            htmlFor="details"
                            className="block text-gray-700 font-medium mb-2"
                        >
                            Veuillez préciser ce que vous souhaitez changer
                        </label>
                        <textarea
                            id="details"
                            name="details"
                            rows="4"
                            required
                            value={formData.details}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    details: e.target.value,
                                }));
                            }}
                            style={{
                                border: "2px dashed var(--border-color)",
                            }}
                            className="w-full border-gray-300 rounded-lg p-2  focus:ring-transparent focus:outline-none"
                            placeholder="Exemple : Je voudrais annuler ma réservation"
                        ></textarea>
                    </div>

                    {/* Submit button */}
                    <div className="flex gap-2">
                        <button
                            type="button"
                            className="px-3 btn bg-gray-300 text-black disabled:cursor-pointer"
                            onClick={() => navigate(-1)}
                            disabled={sending}
                        >
                            Retour
                        </button>
                        <button
                            type="submit"
                            className=" flex-1 w-full btn bg-main-color text-white  disabled:cursor-pointer"
                            disabled={
                                !formData.changeType || !formData.details.trim() || sending
                            }
                        >
                            Envoyer la demande
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};
export default FlightBookingsModificationArea;
